@if ((loading$ | async) === false) {
  <div class="grid">
    <div class="md:col-6 col-12">
      <p-card header="Основные реквизиты">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Сумма</label>
            <p-inputNumber
              [(ngModel)]="task.amount"
              [inputStyle]="{ width: '100%' }"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [class]="errors?.amount ? 'ng-invalid ng-dirty' : ''"
              styleClass="w-full"
              class="w-full">
            </p-inputNumber>
            @if (errors?.amount) {
              <small class="p-error">
                {{ errors.amount | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium required-field">Компания</label>
            <crm-company-single-select
              [(selectedCompany)]="task.company"
              (selectedCompanyChange)="onCompanyChange()"
              [showClear]="true"
              [isError]="$any(errors?.company)"
              appendTo="body"></crm-company-single-select>
            @if (errors?.company) {
              <small class="p-error">
                {{ errors.company | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium required-field">Контрагент</label>
            <crm-contragent-auto-complete
              [(selectedContragent)]="task.contragent"
              (selectedContragentChange)="onContragentChange()"
              [customSearch]="false"
              [showClear]="true"
              [isError]="$any(errors?.contragent)"
              appendTo="body"></crm-contragent-auto-complete>
            @if (errors?.contragent) {
              <small class="p-error">
                {{ errors.contragent | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium required-field">Договор</label>
            <crm-contract-single-select
              [(selectedEntity)]="task.contract"
              [companyIds]="task.company?.id ? [task.company.id] : []"
              [contragentIds]="task.contragent?.id ? [task.contragent.id] : []"
              [styleClass]="errors?.contract ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.contract ? 'ng-invalid ng-dirty' : ''"
              [showClear]="true"
              appendTo="body">
            </crm-contract-single-select>
            @if (errors?.contract) {
              <small class="p-error">
                {{ errors.contract | join }}
              </small>
            }
          </div>

          <div class="field">
            <label class="font-medium">Дедлайн</label>
            <crm-datepicker
              [(value)]="task.deadline"
              [class]="errors?.deadline ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            @if (errors?.deadline) {
              <small class="p-error">
                {{ errors.deadline | join }}
              </small>
            }
          </div>
        </div>
      </p-card>
    </div>

    <div class="md:col-6 col-12">
      <p-card header="Участники">
        <div class="field">
          <label class="font-medium required-field">Ответственный</label>
          <crm-user-single-select
            [(selectedUser)]="task.responsible"
            (selectedUserChange)="onResponsibleChange($event)"
            [isError]="$any(errors?.responsible)"
            [customSearch]="false"
            appendTo="body"></crm-user-single-select>
          @if (errors?.responsible) {
            <p class="p-error">
              {{ errors.responsible | join }}
            </p>
          }
        </div>

        <h3 class="font-medium -mb-2">Аудиторы</h3>
        <p-divider></p-divider>
        <div class="formgrid grid">
          <div class="field lg:col-6 col-12">
            <label class="font-medium">Пользователи</label>
            <crm-user-multi-select
              [(selectedUsers)]="task.userAuditors"
              (selectedUsersChange)="onAuditorsChange($event)"
              [isError]="$any(errors?.userAuditors)"
              [customRequest]="false"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
            @if (errors?.userAuditors) {
              <p class="p-error">
                {{ errors.userAuditors | join }}
              </p>
            }
          </div>

          <div class="field lg:col-6 col-12">
            <label class="font-medium">Группы</label>
            <crm-user-group-multi-select
              [(selectedUserGroups)]="task.userGroupAuditors"
              (selectedUserGroupsChange)="onAuditorGroupsChange($event)"
              [isError]="$any(errors?.userGroupAuditors)"
              [customRequest]="false"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-group-multi-select>
            @if (errors?.userGroupAuditors) {
              <p class="p-error">
                {{ errors.userGroupAuditors | join }}
              </p>
            }
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <p class="text-xl font-medium ml-3">События</p>
    <p-divider></p-divider>
    @for (event of task.events; track event; let index = $index) {
      <p-card styleClass="mb-3 p-3 very-compact-card">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Событие</label>
            <crm-input-text
              [(value)]="event.name"
              [isError]="$any(errors?.events?.[index]?.['name'])"></crm-input-text>
            @if (errors?.events?.[index]?.['name']) {
              <small class="p-error">
                {{ errors.events[index]['name'] | join }}
              </small>
            }
          </div>

          <div class="grid">
            <div class="col">
              <div class="field">
                <label class="font-medium required-field">Тип</label>
                <crm-single-select
                  [options]="eventTypes"
                  [(selectedItem)]="event.type"
                  [filter]="true"
                  [styleClass]="errors?.events?.[index]?.['type'] ? 'ng-invalid ng-dirty' : ''"
                  [class]="errors?.events?.[index]?.['type'] ? 'ng-invalid ng-dirty' : ''"
                  appendTo="body"></crm-single-select>
                @if (errors?.events?.[index]?.['type']) {
                  <small class="p-error">
                    {{ errors.events[index]['type'] | join }}
                  </small>
                }
              </div>
            </div>
            <div class="col">
              <div class="field">
                <label class="font-medium">Эпик</label>
                <crm-master-milestone-single-select
                  [masterMilestones]="masterMilestones"
                  [(selectedMasterMilestone)]="event.masterMilestone"
                  [isError]="$any(errors?.events?.[index]?.['masterMilestone'])"
                  [customRequest]="true"
                  appendTo="body"></crm-master-milestone-single-select>
                @if (errors?.events?.[index]?.['masterMilestone']) {
                  <small class="p-error">
                    {{ errors.events[index]['masterMilestone'] | join }}
                  </small>
                }
              </div>
            </div>
          </div>

          <div class="field">
            <label class="font-medium required-field">Участники</label>
            <crm-user-multi-select
              [users]="participants"
              [(selectedUsers)]="event.responsible"
              [isError]="$any(errors?.events?.[index]?.['responsible'])"
              [customRequest]="true"
              [isFloatLabel]="false"
              appendTo="body"></crm-user-multi-select>
            @if (errors?.events?.[index]?.['responsible']) {
              <small class="p-error">
                {{ errors.events[index]['responsible'] | join }}
              </small>
            }
          </div>

          <crm-checklist-period-form
            [(startAt)]="event.startAt"
            [(endAt)]="event.endAt"
            [errors]="$any(errors?.events?.[index])"
            appendTo="body"></crm-checklist-period-form>

          <div class="field">
            <label class="font-medium">Описание</label>
            <crm-editor [(value)]="event.description"></crm-editor>
            @if (errors?.events?.[index]?.['description']) {
              <small class="p-error">
                {{ errors.events[index]['description'] | join }}
              </small>
            }
          </div>
        </div>

        <div class="flex justify-content-end">
          <crm-button
            type="button"
            icon="pi pi-trash"
            label="Удалить"
            styleClass="p-button-danger p-button-text"
            (onClick)="deleteEvent(event)"></crm-button>
        </div>
      </p-card>
    }

    <crm-button
      type="button"
      icon="pi pi-plus"
      label="Добавить событие"
      styleClass="p-button-success p-button-text"
      (onClick)="addEvent()"></crm-button>
  </div>

  <div class="grid mt-3">
    <div class="md:col-6 col-12 flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTask()"></crm-button>
    </div>
  </div>
} @else {
  <crm-spinner></crm-spinner>
}
